import * as React from 'react';
import { ExclamationTriangleIcon } from '@patternfly/react-icons';
import { Button } from '@patternfly/react-core';
import { useHistory } from 'react-router-dom';

const NotFound: React.FunctionComponent = () => {
  function GoHomeBtn() {
    const history = useHistory();
    function handleClick() {
      history.push('/');
    }
    return (
      <Button onClick={handleClick}>Take me home</Button>
    );
  }

  return (
    <section className="dx-page-section">
      <div className="dx-empty-state dx-empty-state--full">
        <div className="dx-empty-state__icon"><ExclamationTriangleIcon /></div>
        <h1 className="dx-empty-state__title">404 Page not found</h1>
        <div className="dx-empty-state__body">
          We didn&apos;t find a page that matches the address you navigated to.
        </div>
        <div className="dx-empty-state__footer">
          <GoHomeBtn />
        </div>
      </div>
    </section>
  )
};

export { NotFound };
